/* eslint-disable no-useless-catch */
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/document-categories';

export const DocumentCategoryApi = {
  findMasterData: async () => {
    const url = `${pathname}/master-data`;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },
};
